import { TIME_BLOCKS } from '../../../utils'

export const STANDARD_KENNEL_OPTIONS = ['Standard', 'Luxury']
export const FOOD_SCHEDULE_OPTIONS = [
	{
		title: 'Morning',
		category: 'meal',
		time: TIME_BLOCKS.Morning
	},
	{
		title: 'Midday',
		category: 'meal',
		time: TIME_BLOCKS.Midday
	},
	{
		title: 'Evening',
		category: 'meal',
		time: TIME_BLOCKS.Evening
	}
]
